import { combineReducers } from '@reduxjs/toolkit';

import getCartEvents from './get_cart_events';
import getTheftRegistries from './get_theft_registries';
import getPodOrders from './get_pod_orders';
import createTheftRegistry from './create_theft_registry';
import updateTheftRegistryStatus from './update_theft_registry_status';
import getTheftRegistry from './get_theft_registry';
import getTheftRegistriesForStore from './get_theft_registries_for_store';
import getOrders from './get_orders';
import createTheftSms from './create_theft_sms';
import cancelTheftRegistry from './cancel_theft_registry';
import getReservationOrder from './get_reservation_order';
import returnCustomerOrder from './return_customer_order';
import createPodOrder from './create_pod_order';
import updatePodOrderStatus from './update_pod_order_status';

export default combineReducers({
    getCartEvents,
    getTheftRegistries,
    getPodOrders,
    createTheftRegistry,
    updateTheftRegistryStatus,
    getTheftRegistry,
    getTheftRegistriesForStore,
    getOrders,
    createTheftSms,
    cancelTheftRegistry,
    getReservationOrder,
    returnCustomerOrder,
    createPodOrder,
    updatePodOrderStatus
});
